import { createFileRoute } from "@tanstack/react-router";
import { BrandLogosManager } from "@/components/admin/brand-logos-manager";

export const Route = createFileRoute("/_authenticated/admin/brand-logos")({
  component: () => <BrandLogosManager />,
});
